import { render, staticRenderFns } from "./alertText.vue?vue&type=template&id=4af93727&"
import script from "./alertText.vue?vue&type=script&lang=js&"
export * from "./alertText.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/fontFace.css?vue&type=style&index=0&lang=css&"
import style1 from "./alertText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports